/**
 * Client-side mirror of the server's 10-minute analytics cache: a result is
 * reused until the server's expiresAt (10 minutes from the first request),
 * so switching tabs and filters back and forth never re-requests. `force`
 * asks the server to recompute (refresh=true) and replaces the entry.
 */
const CLIENT_CACHE_MS = 10 * 60 * 1000;
const clientCache = new Map();

export const cachedFetch = (name, fn, params, { force = false } = {}) => {
  const key = `${name}:${JSON.stringify(params)}`;
  const hit = clientCache.get(key);
  if (!force && hit && Date.now() < hit.until) return hit.promise;
  const entry = { until: Date.now() + CLIENT_CACHE_MS };
  entry.promise = fn(force ? { ...params, refresh: true } : params)
    .then((r) => {
      const serverExpiry = Date.parse(r?.data?.expiresAt);
      if (!Number.isNaN(serverExpiry)) entry.until = serverExpiry;
      return r;
    })
    .catch((e) => {
      clientCache.delete(key);
      throw e;
    });
  clientCache.set(key, entry);
  return entry.promise;
};
